

const SECONDS_IN_MINUTE = 60;
const SECONDS_IN_HOUR = 60 * 60;
const SECONDS_IN_DAY = SECONDS_IN_HOUR * 24;
const SECONDS_IN_YEAR = SECONDS_IN_DAY * 365;


/**
 * return a "human" time based on the `ageInSeconds` parameter.
 */
function HumanTimeAgo(ageInSeconds) {
  // handle the rare case where the age is negative (i.e., in the future).
  if (ageInSeconds < 1) {
    return 'just now';
  }

  function numberEnding(number) {
    return number > 1 ? 's' : '';
  }

  var years = Math.floor(ageInSeconds / SECONDS_IN_YEAR);
  if (years) {
    return years + ' year' + numberEnding(years) + ' ago';
  }

  var days = Math.floor((ageInSeconds %= SECONDS_IN_YEAR) / SECONDS_IN_DAY);
  if (days) {
    return days + ' day' + numberEnding(days) + ' ago';
  }

  var hours = Math.floor((ageInSeconds %= SECONDS_IN_DAY) / SECONDS_IN_HOUR);
  if (hours) {
    return hours + ' hour' + numberEnding(hours) + ' ago';
  }

  var minutes = Math.floor((ageInSeconds %= SECONDS_IN_HOUR) / SECONDS_IN_MINUTE);
  if (minutes) {
    return minutes + ' minute' + numberEnding(minutes) + ' ago';
  }

  var seconds = ageInSeconds % SECONDS_IN_MINUTE;
  if (seconds) {
    return seconds + ' second' + numberEnding(seconds) + ' ago';
  }

  return 'just now';
}


export { SECONDS_IN_MINUTE, SECONDS_IN_HOUR, SECONDS_IN_DAY, SECONDS_IN_YEAR };

export { HumanTimeAgo };

